module.exports = "<ng-container *ngIf=\"content | async as event\">\n    <ng-container *ngIf=\"event | meta\">\n        <marquee-row [item]=\"event | meta\" [disable]=\"true\"></marquee-row>\n        <detail-row [item]=\"event | meta\"></detail-row>\n        <ng-container *ngIf=\"(event | meta).content\">\n            <content-builder class=\"quote-block\" [items]=\"(event | meta).content\"></content-builder>\n        </ng-container>\n    </ng-container>\n    <rows [rows$]=\"event.rows\"></rows>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/event-container/event-container.component.html
// module id = 860
// module chunks = 2